export enum DictionaryStatuses {
  DELETED = "Удален",
  ACTIVE = "Активный",
  CONCATED = "Объединен",
}
